/* unplugin-vue-components disabled */import { render } from "./bindArea.vue?vue&type=template&id=743056ee&scoped=true"
import script from "./bindArea.vue?vue&type=script&lang=js"
export * from "./bindArea.vue?vue&type=script&lang=js"

import "./bindArea.vue?vue&type=style&index=0&id=743056ee&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743056ee"]])

export default __exports__